import {combineReducers}    from 'redux'
import fetching             from "./FetchingBiddingStrategies"
import list                 from "./BiddingStrategiesList"

export const BiddingStrategies = combineReducers({
  fetching,
  list,
})

